import { 
    PORTFOLIO_DATA_LOADING, 
    ADD_PORTFOLIO_SUCCESS, 
    ADD_PORTFOLIO_FAIL,
} from '../actions/types';
import { axiosInstance } from '../axiosInstance';
import { returnErrors, clearErrors } from '../actions/errorActions';

// Add Portfolio Item

export const addportfolioitem = ({ title, description, video_url, preview_url, skills, keywords, spacing, publish, image, images, id, images_sort, cat_id, sub_cat_id }) => {
    return async function(dispatch, getState){
        dispatch(clearErrors());
        dispatch({
            type: PORTFOLIO_DATA_LOADING
        });
        const body = { title, description, video_url, preview_url, skills, keywords, spacing, publish, image, images, id, images_sort, cat_id, sub_cat_id };
        try {
            let response = await axiosInstance.post(
                '/api/portfolios', 
                body, 
                tokenConfig(getState)
            );
            if(response.status !== 200){
                dispatch({
                    type: ADD_PORTFOLIO_FAIL,
                });
                throw Error({
                    response: {
                        data: "Other Errors",
                        status: "Other Errors"
                    },
                })
            }else{
                dispatch({
                    type: ADD_PORTFOLIO_SUCCESS,
                    payload: response.data
                })
            }
        } catch (error) {
            if (error.response && error.response.data) {
                dispatch(returnErrors(error.response.data, error.response.status, 'ADD_PORTFOLIO_FAIL'));
                dispatch ({ 
                    type: ADD_PORTFOLIO_FAIL 
                });
            }else{
                let errorJson = JSON.stringify(error);
                let errorParsed = JSON.parse(errorJson);
                return (
                    dispatch(returnErrors(errorParsed.message, "Network Error", 'ADD_PORTFOLIO_FAIL')),
                    dispatch ({ 
                        type: ADD_PORTFOLIO_FAIL 
                    })
                )
            }
        }
    }
};


// Setup config/headers and token

export const tokenConfig = getState => {
    // Get token from localStorage
    const token = getState().auth.token;
    //Headers
    const config = {
        headers: {
            "Content-type": "application/json"
        }
    }

    // If token, add to headers

    if (token) {
        config.headers['Authorization'] = 'bearer' + token;
    }

    return config;

}